/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_YesInputs */

const vi_common_yes = /** @type {(inputs: Common_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có`)
};

/**

* @param {Common_YesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_yes = /** @type {((inputs?: Common_YesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_YesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_yes(inputs)
});